(function () {
  const MOBILE_BREAKPOINT = 768;
  const ROTATION_INTERVAL = 4000;

  function initTrustBar() {
    const list = document.querySelector('.trust-bar__list');
    if (!list) return;
    const items = list.querySelectorAll('.trust-bar__item');
    if (items.length <= 1) return;

    const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    let currentIndex = 0;
    let intervalId = null;
    let isMobileMode = false;

    function setActive(index) {
      items.forEach((item, i) => item.classList.toggle('is-active', i === index));
    }

    function startRotation() {
      if (reducedMotion || intervalId) return;
      currentIndex = 0;
      setActive(0);
      intervalId = window.setInterval(() => {
        currentIndex = (currentIndex + 1) % items.length;
        setActive(currentIndex);
      }, ROTATION_INTERVAL);
    }

    function stopRotation() {
      if (intervalId) {
        window.clearInterval(intervalId);
        intervalId = null;
      }
      items.forEach((item) => item.classList.remove('is-active'));
    }

    function checkMode() {
      const isNarrow = window.innerWidth < MOBILE_BREAKPOINT;
      if (isNarrow && !isMobileMode) {
        isMobileMode = true;
        startRotation();
      } else if (!isNarrow && isMobileMode) {
        isMobileMode = false;
        stopRotation();
      }
    }

    checkMode();
    window.addEventListener('resize', checkMode);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initTrustBar);
  } else {
    initTrustBar();
  }
})();
